export const LIMIT = 5;

export const PLATFORMS = [
  'GetIntent',
  'Segmento',
  'Hybrid',
  'MediaSniper',
  'Adriver',
  'Buzzoola',
  'Astralab',
  'Adwist',
  'Onetarget',
  'Plazkart',
  'MgCom',
  'OTM',
  'Yandex Direct',
  'Rambler',
  'Другая'
];
